var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M31.967 12.939a3 3 0 011.098 4.098L24.195 32.4a1 1 0 01-.352.357l-7.064 4.236a1 1 0 01-1.514-.874l.136-8.236a1 1 0 01.134-.483l8.87-15.364a3 3 0 014.098-1.098l3.464 2zM20.892 30.793l-2.313-1.336a1 1 0 00-1.489.715l-.01.117-.1 2.842a1 1 0 001.427.939l.103-.056 2.412-1.507a1 1 0 00.067-1.65l-.097-.064zm8.075-12.658l-3.464-2a1 1 0 00-1.302.268l-.064.098-6.154 10.66 5.196 3 6.154-10.66a1 1 0 00-.268-1.302l-.098-.064z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
